import React from 'react';

import { createNativeStackNavigator } from '@react-navigation/native-stack';

import { BetsScreen } from '@/feature/bets-sbk/screens/BetsScreen';

import { PredictionEntriesStackParamList } from './types';

const Stack = createNativeStackNavigator<PredictionEntriesStackParamList>();

export const EntriesStack = () => {
    return (
        <Stack.Navigator screenOptions={{ headerShown: false }}>
            <Stack.Screen name="EntriesScreen" component={BetsScreen} />
        </Stack.Navigator>
    );
};
